import { combineReducers } from '@reduxjs/toolkit'

import { reducer as addressByPostalCode } from './addressByPostalCode'

export default combineReducers({ addressByPostalCode })
